$(document).ready(function() {
    // KREAN-1120 activate lookbook on hover instead of click.
    $(document).on('hover', '.easypin-marker', (e) => {
        const $el = $(e.target);
        const $popover = $el.find('.easypin-popover');
        if ($popover.is(':hidden')) {
            $el.click();
        }
    })
});
